import type { PriceComponent } from '@niarab2c/frontend-commons/src/types/hotels';
import { NiaraIcon } from '@niaratech/niara-icons';
import { printPrice } from '@niaratech/niara-js-commons';
import { ResponsiveTooltip } from '@niaratech/niara-react-components/src';
import React from 'react';
import { useHotelSearchContext } from '../../HotelSearch';
import { Text } from '../../microComponents';
import formatPenaltyDate, { shouldShowTimezoneMessage } from '../../util/formatPenaltyDate';
import ModalOTA, { type ModalOTAProps } from '../ModalOTA';
import * as S from './styles';
export type PolicyProps = {
  penaltyDate?: string;
  nonRefundable?: boolean | string;
  inPenalty?: boolean | string;
  textSize?: number;
  fontWeight?: any;
  policyDescription?: Description[];
  showPricePolicy?: boolean;
  priceComposition?: {
    penalty?: PriceComponent;
    total?: PriceComponent;
  };
  dateFormat?: string;
  disableIcon?: boolean;
};
type Description = {
  name?: string;
  description?: string;
};
const Policy: React.FC<PolicyProps> = ({
  penaltyDate,
  nonRefundable,
  inPenalty,
  policyDescription,
  textSize,
  fontWeight = 700,
  showPricePolicy = true,
  priceComposition,
  disableIcon
}) => {
  const {
    b2c
  } = useHotelSearchContext();
  const color = nonRefundable || inPenalty ? b2c ? 'textColor' : 'danger' : 'priceColor';
  const propStyle = {
    textColor: color,
    fontWeight: fontWeight,
    textSize: textSize
  };
  const shouldShowTimezone = penaltyDate?.length > 10 && !penaltyDate?.endsWith('T00:00');
  const printTimezone = () => {
    const timezoneOffset = new Date().getTimezoneOffset() / 60;
    if (timezoneOffset > 0) {
      return `UTC-${timezoneOffset}`;
    }
    if (timezoneOffset < 0) {
      return `UTC+${-1 * timezoneOffset}`;
    } else {
      return 'UTC';
    }
  };
  return <ResponsiveTooltip<ModalOTAProps> modalComponent={ModalOTA} ModalProps={{
    title: "Política de cancelamento",
    stickyHeader: true
  }} renderContent={() => {
    return <>
            {shouldShowTimezone && penaltyDate != null && shouldShowTimezoneMessage(penaltyDate, inPenalty) && <Text as="p" fontSize="14px">
                Horário no fuso horário {printTimezone()}
              </Text>}
            {priceComposition?.total?.value > 0 && <Text as="p" fontSize="14px">
                Taxa após prazo: {printPrice(priceComposition?.total?.value, priceComposition?.total?.currency)}
              </Text>}
            {policyDescription?.map((description, idx) => <React.Fragment key={idx}>
                <S.ContainerText>
                  <Text as="h3" my="10px" fontSize="14px" fontWeight="700">
                    {description?.name}
                  </Text>
                </S.ContainerText>
                <Text as="p" fontSize="14px">
                  {description?.description}
                </Text>
              </React.Fragment>)}
          </>;
  }}>
      <>
        {nonRefundable ? <S.PolItem {...propStyle}>
            <>
              {disableIcon ? null : <>
                  <NiaraIcon color={color} icon="sysNoRefundable" />
                  &nbsp;
                </>}
              <>Não reembolsável</>
              {showPricePolicy && <>
                  &nbsp;
                  <NiaraIcon color="#9C9C9C" icon="sysInfo" />
                </>}
            </>
          </S.PolItem> : inPenalty ? <S.PolItem {...propStyle}>
            <>
              {disableIcon ? null : <>
                  <NiaraIcon icon="sysClose" />
                  &nbsp;
                </>}
              <>Cancelamento com multa</>
              {showPricePolicy && <>
                  &nbsp;
                  <NiaraIcon color="#9C9C9C" icon="sysInfo" />
                </>}
            </>
          </S.PolItem> : penaltyDate != null ? <S.PolItem {...propStyle}>
            <>
              {disableIcon ? null : <>
                  <NiaraIcon icon="sysCheck" />
                  &nbsp;
                </>}
              <>Cancelamento grátis até {formatPenaltyDate(penaltyDate)}</>
              {showPricePolicy && <>
                  &nbsp;
                  <NiaraIcon color="#9C9C9C" icon="sysInfo" />
                </>}
            </>
          </S.PolItem> : null}
      </>
    </ResponsiveTooltip>;
};
export default Policy;